module.exports = __webpack_public_path__ + "04_long_gold.52f2db29.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/04_long_gold.png
// module id = v9tx
// module chunks = 0